export default __webpack_public_path__ + "static/sunflower-631389dc1202b7d6e5606395130af48c.png";